<template lang="pug">
  RegistrationForm(@submit="handleSubmit")
    template(#header)
      FormHeader(tag="h2") Зарегистрироваться
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    computed: {
      ...mapState([
        'possibleInterestIds',
        'interestType',
        'interestId',
        'interestOptions',
        'submitting',
        'submitted',
      ]),
    },

    methods: {
      ...mapActions(['submit']),

      handleSubmit ({ email, name, phone, gdprConfirmed, newsletter, recaptchaResponse }) {
        const { interestId, interestType } = this;

        this.submit({
          email,
          name,
          phone,
          gdprConfirmed,
          newsletter,
          recaptchaResponse,
          interestId,
          interestType,
        });
      },
    },
  };
</script>
